export default {
    'buildVersion': '4.7.10',
    'buildDate': '2025-05-13 14:31'
};
